// Conversa do Chat Interno no padrão Aeros (mockup "Chat Interno A" +
// "Ações de mensagem A"): header com participantes/online/avatares e menu,
// bolhas (minhas roxas à direita, dos outros cinza à esquerda, avatar só na
// primeira da sequência), divisor de data, citação, "Encaminhada",
// "editada · hh:mm ✓✓", mensagem apagada (admin vê o original), toolbar no
// hover, composer com resposta ativa / anexo pendente / gravação.
// A lógica de envio, mídia, áudio, leitura e scroll incremental é a de sempre.
import React, { Fragment, useContext, useEffect, useMemo, useRef, useState } from "react";
import { makeStyles, alpha } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import Tooltip from "@material-ui/core/Tooltip";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from "@material-ui/core/CircularProgress";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Button from "@material-ui/core/Button";
import GroupIcon from "@material-ui/icons/Group";
import SearchIcon from "@material-ui/icons/Search";
import EditIcon from "@material-ui/icons/Edit";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import MoodIcon from "@material-ui/icons/Mood";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import MicIcon from "@material-ui/icons/Mic";
import SendIcon from "@material-ui/icons/Send";
import CloseIcon from "@material-ui/icons/Close";
import ReplyIcon from "@material-ui/icons/Reply";
import ForwardIcon from "@material-ui/icons/Forward";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import BlockIcon from "@material-ui/icons/Block";
import CheckIcon from "@material-ui/icons/Check";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ImageOutlinedIcon from "@material-ui/icons/ImageOutlined";
import InsertDriveFileOutlinedIcon from "@material-ui/icons/InsertDriveFileOutlined";
import GetAppIcon from "@material-ui/icons/GetApp";
import NotificationsOffIcon from "@material-ui/icons/NotificationsOff";
import NotificationsActiveIcon from "@material-ui/icons/NotificationsActive";
import ConfirmationNumberOutlinedIcon from "@material-ui/icons/ConfirmationNumberOutlined";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import InsertEmoticonIcon from "@material-ui/icons/InsertEmoticon";
import Popover from "@material-ui/core/Popover";
import { useHistory } from "react-router-dom";
import { Picker } from "emoji-mart";
import "emoji-mart/css/emoji-mart.css";
import MicRecorder from "mic-recorder-to-mp3";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { i18n } from "../../translate/i18n";
import MarkdownWrapper from "../../components/MarkdownWrapper";
import RecordingTimer from "../../components/MessageInput/RecordingTimer";
import ModalImageCors from "../../components/ModalImageCors";
import AudioModal from "../../components/AudioModal";
import DocumentModal from "../../components/DocumentModal";
import { AEROS, stateText } from "../../styles/aerosTokens";
import { chatTitle, isGroup, otherUserOf, initialsOf, avatarColorFor, dayLabel, isContinuation, onlineCount, isMuted, groupReactions, QUICK_REACTIONS, mentionQuery, applyMention, typingLabel } from "./chatRules";
import { profileImageUrl, groupImageUrl } from "./ChatList";

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

const useStyles = makeStyles((theme) => {
  const isLight = theme.palette.type === "light";
  const purpleText = stateText(theme, "#C08BFF", "purple");
  const cyanText = stateText(theme, AEROS.cyan, "info");
  const border = isLight ? theme.palette.divider : "rgba(255,255,255,0.06)";
  const bubbleOther = isLight ? "#FFFFFF" : "#1A1E2C";
  return {
    root: { display: "flex", flexDirection: "column", height: "100%", minHeight: 0 },
    header: { height: 64, flexShrink: 0, display: "flex", alignItems: "center", padding: "0 20px", borderBottom: `1px solid ${border}`, gap: 12, [theme.breakpoints.down("sm")]: { padding: "0 10px" } },
    headAvatar: { width: 38, height: 38, borderRadius: 12, backgroundColor: "rgba(160,68,255,0.15)", display: "flex", alignItems: "center", justifyContent: "center", color: purpleText, overflow: "hidden", flex: "none", "& .MuiSvgIcon-root": { fontSize: 19 }, "& img": { width: "100%", height: "100%", objectFit: "cover" } },
    headDm: { borderRadius: "50%", fontSize: 12, fontWeight: 700, color: "#07080D" },
    headTitle: { fontSize: 14, fontWeight: 700, color: theme.palette.text.primary, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
    headSub: { fontSize: 11.5, color: theme.palette.text.secondary, display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" },
    online: { color: stateText(theme, AEROS.success, "success") },
    headActions: { marginLeft: "auto", display: "flex", gap: 6, alignItems: "center" },
    stack: { display: "flex", marginRight: 6 },
    stackAvatar: { width: 26, height: 26, borderRadius: "50%", border: `2px solid ${theme.palette.aeros.background}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, fontWeight: 800, color: "#07080D", marginLeft: -8, "&:first-child": { marginLeft: 0 } },
    stackMore: { backgroundColor: isLight ? "#E5E7EB" : "#1A1E2C", color: theme.palette.text.secondary, fontWeight: 700 },
    iconBtn: { width: 32, height: 32, borderRadius: 9, border: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.1)"}`, color: theme.palette.text.secondary, padding: 0, "& .MuiSvgIcon-root": { fontSize: 18 } },
    menuPaper: { width: 220, padding: 6, borderRadius: 12, backgroundColor: theme.palette.aeros.surface2 || theme.palette.background.paper, border: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.12)"}`, boxShadow: "0 8px 24px rgba(0,0,0,0.5)", "& .MuiList-root": { padding: 0 } },
    menuSection: { fontSize: 10, fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: theme.palette.aeros.textTertiary, padding: "8px 12px 4px" },
    menuItem: { display: "flex", alignItems: "center", gap: 10, padding: "9px 12px", borderRadius: 8, fontSize: 13, color: theme.palette.text.primary, "& .MuiSvgIcon-root": { fontSize: 17, color: theme.palette.text.secondary }, "&:hover": { backgroundColor: "rgba(160,68,255,0.12)" } },
    menuWarn: { color: stateText(theme, AEROS.warning, "warning"), "& .MuiSvgIcon-root": { color: "inherit" } },
    menuDanger: { color: stateText(theme, AEROS.error, "error"), "& .MuiSvgIcon-root": { color: "inherit" } },
    menuDivider: { height: 1, backgroundColor: isLight ? theme.palette.divider : "rgba(255,255,255,0.07)", margin: "5px 8px" },
    searchBar: { padding: "8px 20px", borderBottom: `1px solid ${border}`, display: "flex", gap: 8, alignItems: "center" },
    searchInput: { flex: 1, backgroundColor: theme.palette.aeros.surface, border: `1px solid ${isLight ? theme.palette.aeros.borderStrong : "rgba(255,255,255,0.1)"}`, borderRadius: 10, padding: "3px 12px", fontSize: 13, color: theme.palette.text.primary, display: "flex", gap: 8, alignItems: "center", "& .MuiSvgIcon-root": { fontSize: 16, color: theme.palette.text.secondary } },
    list: { flex: 1, minHeight: 0, overflowY: "auto", backgroundColor: theme.palette.aeros.sidebar, padding: "20px 24px", display: "flex", flexDirection: "column", gap: 6, ...theme.scrollbarStyles, [theme.breakpoints.down("sm")]: { padding: "12px" } },
    loadingMore: { display: "flex", justifyContent: "center", padding: 8, position: "sticky", top: 0, zIndex: 1 },
    divider: { alignSelf: "center", fontSize: 10.5, fontWeight: 600, color: theme.palette.aeros.textTertiary, backgroundColor: isLight ? "rgba(15,20,40,0.05)" : "rgba(255,255,255,0.04)", borderRadius: 99, padding: "3px 12px", margin: "6px 0" },
    system: { alignSelf: "center", fontSize: 10.5, fontWeight: 600, color: cyanText, backgroundColor: alpha(AEROS.cyan, 0.08), border: `1px dashed ${alpha(AEROS.cyan, 0.3)}`, borderRadius: 99, padding: "3px 12px", margin: "4px 0" },
    row: { display: "flex", gap: 10, maxWidth: "68%", position: "relative", [theme.breakpoints.down("sm")]: { maxWidth: "88%" } },
    rowMe: { alignSelf: "flex-end", flexDirection: "row-reverse" },
    rowOther: { alignSelf: "flex-start" },
    avatar: { width: 28, height: 28, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, fontWeight: 800, color: "#07080D", flex: "none", alignSelf: "flex-end", overflow: "hidden", "& img": { width: "100%", height: "100%", objectFit: "cover" } },
    avatarGap: { width: 28, flex: "none" },
    bubble: { borderRadius: "14px 14px 14px 4px", padding: "9px 13px", minWidth: 0, position: "relative", border: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.07)"}`, backgroundColor: bubbleOther, color: theme.palette.text.primary, "&:hover $toolbar": { opacity: 1, pointerEvents: "auto" } },
    bubbleMe: { borderRadius: "14px 14px 4px 14px", backgroundColor: "rgba(160,68,255,0.16)", borderColor: "rgba(160,68,255,0.3)" },
    bubbleDeleted: { border: `1px dashed ${isLight ? theme.palette.aeros.borderStrong : "rgba(255,255,255,0.12)"}` },
    highlight: { boxShadow: `0 0 0 2px ${alpha(AEROS.cyan, 0.6)}` },
    sender: { fontSize: 11, fontWeight: 700, marginBottom: 3 },
    text: { fontSize: 13.5, lineHeight: 1.5, whiteSpace: "pre-wrap", wordBreak: "break-word", "& p": { margin: 0 } },
    meta: { fontSize: 10.5, color: theme.palette.aeros.textTertiary, textAlign: "right", marginTop: 3, display: "flex", justifyContent: "flex-end", gap: 5, alignItems: "center", "& i": { fontStyle: "italic" } },
    metaMe: { color: theme.palette.text.secondary },
    quote: { borderLeft: `3px solid ${AEROS.cyan}`, backgroundColor: isLight ? "rgba(15,20,40,0.05)" : "rgba(7,8,13,0.4)", borderRadius: 6, padding: "6px 10px", marginBottom: 6, cursor: "pointer", minWidth: 0 },
    quoteName: { fontSize: 11, fontWeight: 700, color: cyanText },
    quoteText: { fontSize: 12, color: theme.palette.text.secondary, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
    forwarded: { display: "flex", alignItems: "center", gap: 5, fontSize: 10.5, color: theme.palette.text.secondary, marginBottom: 6, "& .MuiSvgIcon-root": { fontSize: 13 } },
    deletedText: { fontSize: 12.5, color: theme.palette.aeros.textTertiary, fontStyle: "italic", display: "flex", alignItems: "center", gap: 5, "& .MuiSvgIcon-root": { fontSize: 14 } },
    deletedAdmin: { fontSize: 10.5, color: stateText(theme, AEROS.warning, "warning"), marginTop: 4, display: "flex", alignItems: "center", gap: 4, "& .MuiSvgIcon-root": { fontSize: 12 } },
    media: { marginBottom: 6, "& img, & video": { maxWidth: "100%", borderRadius: 8 } },
    toolbar: { position: "absolute", top: -16, right: 8, display: "flex", gap: 2, backgroundColor: theme.palette.aeros.surface2 || theme.palette.background.paper, border: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.12)"}`, borderRadius: 9, padding: 3, boxShadow: "0 8px 24px rgba(0,0,0,0.5)", opacity: 0, pointerEvents: "none", transition: "opacity .12s", zIndex: 2 },
    toolBtn: { width: 26, height: 26, borderRadius: 6, padding: 0, color: theme.palette.text.secondary, "& .MuiSvgIcon-root": { fontSize: 15 }, "&:hover": { color: cyanText, backgroundColor: "rgba(160,68,255,0.1)" } },
    toolDanger: { color: stateText(theme, AEROS.error, "error"), "&:hover": { color: AEROS.error } },
    toolSep: { width: 1, backgroundColor: isLight ? theme.palette.divider : "rgba(255,255,255,0.1)", margin: "4px 2px" },
    footer: { flexShrink: 0, padding: "14px 20px", borderTop: `1px solid ${border}`, [theme.breakpoints.down("sm")]: { padding: "10px" } },
    composer: { backgroundColor: theme.palette.aeros.surface, border: `1px solid ${isLight ? theme.palette.aeros.borderStrong : "rgba(255,255,255,0.1)"}`, borderRadius: 12, overflow: "visible", position: "relative" },
    replyBar: { display: "flex", alignItems: "center", gap: 10, padding: "8px 14px", backgroundColor: alpha(AEROS.cyan, 0.06), borderBottom: `1px solid ${border}`, borderLeft: `3px solid ${AEROS.cyan}`, borderRadius: "12px 12px 0 0" },
    replyName: { fontSize: 11, fontWeight: 700, color: cyanText },
    replyText: { fontSize: 12, color: theme.palette.text.secondary, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
    inputRow: { display: "flex", gap: 10, alignItems: "center", padding: "6px 14px" },
    compIcon: { padding: 4, color: theme.palette.text.secondary, "& .MuiSvgIcon-root": { fontSize: 20 } },
    input: { flex: 1, fontSize: 13.5, color: theme.palette.text.primary, "& textarea::placeholder": { color: theme.palette.aeros.textTertiary, opacity: 1 } },
    sendBtn: { width: 36, height: 36, borderRadius: 10, background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${AEROS.cyan})`, color: "#07080D", padding: 0, flex: "none", "& .MuiSvgIcon-root": { fontSize: 18 }, "&:hover": { opacity: 0.9, background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${AEROS.cyan})` }, "&.Mui-disabled": { opacity: 0.4, color: "#07080D" } },
    sendOk: { background: AEROS.success, "&:hover": { background: AEROS.success } },
    fileCard: { display: "flex", gap: 10, alignItems: "center", padding: "10px 14px" },
    fileIcon: { width: 34, height: 34, borderRadius: 9, backgroundColor: alpha(AEROS.cyan, 0.12), color: cyanText, display: "flex", alignItems: "center", justifyContent: "center", "& .MuiSvgIcon-root": { fontSize: 18 } },
    fileName: { fontSize: 13, fontWeight: 600, color: theme.palette.text.primary, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
    fileMeta: { fontSize: 11, color: theme.palette.text.secondary },
    recRow: { display: "flex", gap: 12, alignItems: "center", padding: "10px 14px", border: `1px solid ${alpha(AEROS.error, 0.3)}`, borderRadius: 12 },
    recCancel: { width: 30, height: 30, borderRadius: 8, border: `1px solid ${alpha(AEROS.error, 0.4)}`, color: stateText(theme, AEROS.error, "error"), padding: 0, "& .MuiSvgIcon-root": { fontSize: 16 } },
    recDot: { width: 8, height: 8, borderRadius: "50%", backgroundColor: AEROS.error, animation: "$pulse 1s infinite" },
    "@keyframes pulse": { "0%, 100%": { opacity: 1 }, "50%": { opacity: 0.3 } },
    recTimer: { fontSize: 13, fontWeight: 700, fontVariantNumeric: "tabular-nums", color: theme.palette.text.primary, "& > div": { margin: 0 } },
    wave: { flex: 1, display: "flex", gap: 2, alignItems: "center", height: 22 },
    waveBar: { width: 3, borderRadius: 2, backgroundColor: alpha(AEROS.cyan, 0.6) },
    emojiBox: { position: "absolute", bottom: 56, left: 0, zIndex: 10 },
    empty: { flex: 1, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, color: theme.palette.aeros.textTertiary },
    docBtn: { fontSize: 12, borderRadius: 8, padding: "4px 10px", "& .MuiSvgIcon-root": { fontSize: 16 } },
    typing: { color: cyanText },
    ticketCard: { display: "flex", alignItems: "center", gap: 8, backgroundColor: isLight ? "rgba(15,20,40,0.05)" : "rgba(7,8,13,0.5)", border: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.08)"}`, borderRadius: 9, padding: "8px 10px", marginBottom: 8, cursor: "pointer", "& > .MuiSvgIcon-root:first-child": { fontSize: 16, color: cyanText }, "& > .MuiSvgIcon-root:last-child": { fontSize: 15, color: theme.palette.text.secondary } },
    ticketTitle: { fontSize: 12, fontWeight: 600, color: theme.palette.text.primary },
    ticketSub: { fontSize: 10.5, color: theme.palette.text.secondary },
    reactions: { display: "flex", gap: 4, flexWrap: "wrap", marginTop: 6 },
    reaction: { display: "inline-flex", alignItems: "center", gap: 4, borderRadius: 99, padding: "1px 7px", border: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.12)"}`, background: "none", cursor: "pointer", color: theme.palette.text.secondary, font: "inherit", fontSize: 11 },
    reactionMine: { borderColor: alpha(AEROS.cyan, 0.5), backgroundColor: alpha(AEROS.cyan, 0.1), color: cyanText },
    reactPicker: { display: "flex", gap: 2, padding: 4, "& button": { width: 30, height: 30, borderRadius: 8, border: "none", background: "none", cursor: "pointer", fontSize: 18, "&:hover": { backgroundColor: "rgba(160,68,255,0.12)" } } },
    mentionPop: { width: 260, padding: 4, borderRadius: 12, backgroundColor: theme.palette.aeros.surface2 || theme.palette.background.paper, border: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.12)"}` },
    mentionRow: { display: "flex", alignItems: "center", gap: 8, padding: "7px 10px", borderRadius: 8, cursor: "pointer", width: "100%", background: "none", border: "none", font: "inherit", color: theme.palette.text.primary, textAlign: "left", fontSize: 13, "&:hover": { backgroundColor: "rgba(160,68,255,0.12)" } },
    mentionAvatar: { width: 22, height: 22, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 8, fontWeight: 800, color: "#07080D" },
    ticketPop: { width: 300, padding: 14, borderRadius: 12, backgroundColor: theme.palette.aeros.surface2 || theme.palette.background.paper, border: `1px solid ${isLight ? theme.palette.divider : "rgba(255,255,255,0.12)"}`, display: "flex", flexDirection: "column", gap: 10 },
    ticketInput: { backgroundColor: theme.palette.aeros.surface, border: `1px solid ${isLight ? theme.palette.aeros.borderStrong : "rgba(255,255,255,0.1)"}`, borderRadius: 10, padding: "4px 12px", fontSize: 13, color: theme.palette.text.primary },
    pendingTicket: { display: "flex", alignItems: "center", gap: 8, padding: "6px 14px", borderBottom: `1px solid ${border}`, fontSize: 12, color: theme.palette.text.secondary, "& .MuiSvgIcon-root": { fontSize: 15, color: cyanText } },
    compIconOn: { color: cyanText },
  };
});

const WAVE = [6, 10, 14, 18, 12, 8, 16, 20, 14, 9, 6, 11, 17, 21, 15, 10, 7, 12, 18, 13, 8, 6, 9, 15, 19, 14, 10, 7, 5, 8];

const formatBytes = (b) => (b < 1024 * 1024 ? `${Math.round(b / 1024)} KB` : `${(b / (1024 * 1024)).toFixed(1).replace(".", ",")} MB`);
const hhmm = (d) => new Date(d).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });

export default function ChatMessages({
  chat,
  messages,
  loading,
  loadingMore,
  pageInfo,
  handleLoadMore,
  onEdit,
  onDelete,
  onForward,
  justOpenedChat,
  setJustOpenedChat,
  scrollToBottomRef,
  addOptimisticMessage,
  onlineUsers,
  onOpenInfo,
  onEditGroup,
  onDeleteChat,
  onLeaveGroup,
  onToggleMute,
  typingUsers,
  onBack,
}) {
  const history = useHistory();
  const classes = useStyles();
  const { user, socket } = useContext(AuthContext);
  const isAdmin = user.profile === "admin";
  const baseRef = useRef();
  const listRef = useRef();
  const inputRef = useRef();
  const messageRefs = useRef({});

  const [contentMessage, setContentMessage] = useState("");
  const [medias, setMedias] = useState([]);
  const [sending, setSending] = useState(false);
  const [recording, setRecording] = useState(false);
  const [showEmoji, setShowEmoji] = useState(false);
  const [replyingTo, setReplyingTo] = useState(null);
  const [initialScrollDone, setInitialScrollDone] = useState(false);
  const [canLoadMore, setCanLoadMore] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [documentModal, setDocumentModal] = useState(null);
  const [highlighted, setHighlighted] = useState(null);
  const [reactAnchor, setReactAnchor] = useState(null); // { el, message }
  const [ticketAnchor, setTicketAnchor] = useState(null);
  const [ticketNumber, setTicketNumber] = useState("");
  const [ticketPreview, setTicketPreview] = useState(null);
  const [pendingTicket, setPendingTicket] = useState(null);
  const typingRef = useRef({ on: false, timer: null });

  const grp = isGroup(chat);
  const other = otherUserOf(chat, user.id);
  const online = useMemo(() => new Set((onlineUsers || []).filter((u) => u.online).map((u) => Number(u.id))), [onlineUsers]);
  const members = chat?.users || [];
  const isOwner = Number(chat?.ownerId) === Number(user.id);
  const muted = isMuted(chat, user.id);
  const mention = mentionQuery(contentMessage);
  const mentionOptions = mention === null ? [] : members.filter((u) => Number(u.userId) !== Number(user.id) && u.user?.name && u.user.name.toLowerCase().includes(mention.toLowerCase())).slice(0, 6);

  // "Fulano está digitando…": emite ao digitar e desliga 2 s depois de parar.
  const emitTyping = (on) => {
    if (!socket || !chat?.id) return;
    socket.emit("chat:typing", { chatId: chat.id, typing: on });
    typingRef.current.on = on;
  };
  const onTypingChange = () => {
    if (!typingRef.current.on) emitTyping(true);
    clearTimeout(typingRef.current.timer);
    typingRef.current.timer = setTimeout(() => emitTyping(false), 2000);
  };
  useEffect(() => () => { clearTimeout(typingRef.current.timer); if (typingRef.current.on) emitTyping(false); }, [chat?.id]); // eslint-disable-line react-hooks/exhaustive-deps

  const react = async (message, emoji) => {
    setReactAnchor(null);
    try {
      await api.post(`/chats/messages/${message.id}/react`, { emoji });
    } catch (err) {
      toastError(err);
    }
  };

  const ticketReqRef = useRef(0);
  const loadTicketPreview = async (n) => {
    setTicketPreview(null);
    if (!n) return;
    const req = ++ticketReqRef.current; // descarta resposta de digitação anterior ("1" chegando depois de "11")
    try {
      const { data } = await api.get(`/tickets/${n}`);
      if (req === ticketReqRef.current) setTicketPreview(data);
    } catch (err) {
      if (req === ticketReqRef.current) setTicketPreview({ error: true });
    }
  };

  // ---- scroll / leitura (mesma lógica de sempre) ----
  const scrollToBottom = () => {
    if (listRef.current) listRef.current.scrollTop = listRef.current.scrollHeight;
  };
  useEffect(() => {
    if (justOpenedChat) setInitialScrollDone(false);
  }, [justOpenedChat]);
  useEffect(() => {
    scrollToBottomRef.current = scrollToBottom;
    if (chat?.id && members.find((u) => Number(u.userId) === Number(user.id))?.unreads > 0) {
      api.post(`/chats/${chat.id}/read`, { userId: user.id }).catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chat?.id]);
  useEffect(() => {
    if (!messages || messages.length === 0 || loadingMore || initialScrollDone) return;
    requestAnimationFrame(() => setTimeout(() => { scrollToBottom(); setInitialScrollDone(true); }, 100));
  }, [messages, loadingMore, initialScrollDone]);
  useEffect(() => {
    if (!loading && !loadingMore && initialScrollDone) setCanLoadMore(true);
  }, [loading, loadingMore, initialScrollDone]);
  useEffect(() => {
    if (justOpenedChat && messages && messages.length > 0) {
      requestAnimationFrame(() => setTimeout(() => { scrollToBottom(); setJustOpenedChat(false); }, 200));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [justOpenedChat, messages]);

  const handleScroll = (e) => {
    if (!initialScrollDone || !canLoadMore || !pageInfo?.hasMore || loading) return;
    if (e.currentTarget.scrollTop < 200) handleLoadMore();
  };

  // ---- envio ----
  const sendText = async (content) => {
    if (!content.trim()) return;
    addOptimisticMessage({
      id: `temp-${Date.now()}`,
      chatId: chat.id,
      senderId: user.id,
      message: content,
      createdAt: new Date().toISOString(),
      sender: { id: user.id, name: user.name, profileImage: user.profileImage },
      replyTo: replyingTo,
      ticket: pendingTicket,
      isDeleted: false,
      isEdited: false,
      mediaType: "text",
    });
    setContentMessage("");
    setReplyingTo(null);
    const ticketId = pendingTicket?.id;
    setPendingTicket(null);
    clearTimeout(typingRef.current.timer);
    if (typingRef.current.on) emitTyping(false);
    try {
      await api.post(`/chats/${chat.id}/messages`, { message: content, replyToId: replyingTo?.id, ticketId });
    } catch (err) {
      toastError(err);
    }
  };

  const sendMedia = async () => {
    setSending(true);
    const fd = new FormData();
    fd.append("fromMe", true);
    medias.forEach((m) => {
      fd.append("typeArch", "chat");
      fd.append("fileId", chat.id);
      fd.append("medias", m);
      fd.append("body", m.name);
    });
    try {
      await api.post(`/chats/${chat.id}/messages`, fd);
      setMedias([]);
    } catch (err) {
      toastError(err);
    } finally {
      setSending(false);
    }
  };

  const startRecording = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      await Mp3Recorder.start();
      setRecording(true);
    } catch (err) {
      toastError(err);
    }
  };
  const sendAudio = async () => {
    setSending(true);
    try {
      const [, blob] = await Mp3Recorder.stop().getMp3();
      if (blob.size >= 10000) {
        const fd = new FormData();
        const filename = `audio-${Date.now()}.mp3`;
        fd.append("typeArch", "chat");
        fd.append("fileId", chat.id);
        fd.append("medias", blob, filename);
        fd.append("body", filename);
        fd.append("fromMe", true);
        await api.post(`/chats/${chat.id}/messages`, fd);
      }
    } catch (err) {
      toastError(err);
    } finally {
      setRecording(false);
      setSending(false);
    }
  };
  const cancelAudio = async () => {
    try {
      await Mp3Recorder.stop().getMp3();
    } catch (err) {
      // gravação já parada
    }
    setRecording(false);
  };

  const copyText = (m) => {
    navigator.clipboard?.writeText(m.message || "").then(() => toast.success(i18n.t("chatMessages.copied")));
  };

  const scrollToMessage = (id) => {
    const el = messageRefs.current[id];
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    setHighlighted(id);
    setTimeout(() => setHighlighted(null), 1500);
  };

  const renderMedia = (m) => {
    if (!m.mediaPath) return null;
    if (m.mediaType === "image") return <div className={classes.media}><ModalImageCors imageUrl={m.mediaPath} /></div>;
    if (m.mediaType === "audio") return <div className={classes.media}><AudioModal url={m.mediaPath} message={m} disableTranscription={!grp} /></div>;
    if (m.mediaType === "video") return <div className={classes.media}><video src={m.mediaPath} controls /></div>;
    return (
      <div className={classes.media}>
        <Button size="small" variant="outlined" className={classes.docBtn} startIcon={<GetAppIcon />} onClick={() => setDocumentModal(m)}>
          {m.mediaName || i18n.t("chatMessages.document")}
        </Button>
      </div>
    );
  };

  const visible = useMemo(() => {
    const t = search.trim().toLowerCase();
    if (!t) return messages || [];
    return (messages || []).filter((m) => String(m.message || "").toLowerCase().includes(t));
  }, [messages, search]);

  const canEdit = (m) => Number(m.senderId) === Number(user.id) && !m.isDeleted && new Date() - new Date(m.createdAt) < 10 * 60 * 1000;

  if (!chat?.id) return <div className={classes.empty}>{i18n.t("chatIndex.selectChat")}</div>;

  // Eu estou na tela: conto como online mesmo antes do users:online chegar.
  const onCount = onlineCount(chat, onlineUsers) + (members.some((u) => Number(u.userId) === Number(user.id)) && !online.has(Number(user.id)) ? 1 : 0);
  const headImg = grp ? groupImageUrl(chat) : profileImageUrl(other);

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        {onBack && (
          <IconButton className={classes.iconBtn} onClick={onBack} aria-label={i18n.t("aeros.chat.back")}>
            <ArrowBackIcon />
          </IconButton>
        )}
        <div className={`${classes.headAvatar} ${grp ? "" : classes.headDm}`} style={grp ? undefined : { backgroundColor: avatarColorFor(other?.id) }}>
          {headImg ? <img src={headImg} alt="" /> : grp ? <GroupIcon /> : initialsOf(other?.name)}
        </div>
        <div style={{ minWidth: 0 }}>
          <div className={classes.headTitle}>{chatTitle(chat, user.id)}</div>
          <div className={classes.headSub}>
            {grp ? (
              <>
                {i18n.t("chatIndex.participants", { count: members.length })} · <span className={classes.online}>{i18n.t("chatIndex.online", { count: onCount })}</span>
                {typingLabel(typingUsers) && <> · <span className={classes.typing}>{typingLabel(typingUsers)}</span></>}
              </>
            ) : typingLabel(typingUsers) ? (
              <span className={classes.typing}>{typingLabel(typingUsers)}</span>
            ) : (
              <span className={other && online.has(Number(other.id)) ? classes.online : undefined}>{other && online.has(Number(other.id)) ? i18n.t("chatIndex.onlineNow") : i18n.t("chatIndex.offline")}</span>
            )}
          </div>
        </div>
        <div className={classes.headActions}>
          {grp && (
            <div className={classes.stack}>
              {members.slice(0, 3).map((u) => (
                <span key={u.userId} className={classes.stackAvatar} style={{ backgroundColor: avatarColorFor(u.userId) }} title={u.user?.name}>
                  {initialsOf(u.user?.name)}
                </span>
              ))}
              {members.length > 3 && <span className={`${classes.stackAvatar} ${classes.stackMore}`}>+{members.length - 3}</span>}
            </div>
          )}
          <Tooltip title={i18n.t("chatIndex.searchInChat")}>
            <IconButton className={classes.iconBtn} onClick={() => { setSearchOpen((v) => !v); setSearch(""); }} aria-label={i18n.t("chatIndex.searchInChat")}>
              <SearchIcon />
            </IconButton>
          </Tooltip>
          {grp && (isAdmin || isOwner) && (
            <Tooltip title={i18n.t("chatIndex.editGroup")}>
              <IconButton className={classes.iconBtn} onClick={onEditGroup} aria-label={i18n.t("chatIndex.editGroup")}>
                <EditIcon />
              </IconButton>
            </Tooltip>
          )}
          <IconButton className={classes.iconBtn} onClick={(e) => setMenuAnchor(e.currentTarget)} aria-label={i18n.t("aeros.chat.more")}>
            <MoreVertIcon />
          </IconButton>
          <Menu open={Boolean(menuAnchor)} anchorEl={menuAnchor} onClose={() => setMenuAnchor(null)} getContentAnchorEl={null} anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }} PaperProps={{ className: classes.menuPaper }}>
            <div className={classes.menuSection}>{i18n.t("chatIndex.menu.section")}</div>
            <MenuItem className={classes.menuItem} onClick={() => { setMenuAnchor(null); onOpenInfo(); }}>
              <InfoOutlinedIcon /> {i18n.t(grp ? "chatIndex.menu.details" : "chatIndex.menu.detailsDm")}
            </MenuItem>
            {grp && (isAdmin || isOwner) && (
              <MenuItem className={classes.menuItem} onClick={() => { setMenuAnchor(null); onEditGroup(); }}>
                <EditIcon /> {i18n.t("chatIndex.menu.edit")}
              </MenuItem>
            )}
            <MenuItem className={classes.menuItem} onClick={() => { setMenuAnchor(null); onToggleMute(); }}>
              {muted ? <NotificationsActiveIcon /> : <NotificationsOffIcon />} {i18n.t(muted ? "chatIndex.menu.unmute" : "chatIndex.menu.mute")}
            </MenuItem>
            <MenuItem className={classes.menuItem} onClick={() => { setMenuAnchor(null); api.post(`/chats/${chat.id}/read`, { userId: user.id }).catch(() => {}); }}>
              <DoneAllIcon /> {i18n.t("chatIndex.menu.markRead")}
            </MenuItem>
            <div className={classes.menuDivider} />
            {grp && !isOwner && (
              <MenuItem className={`${classes.menuItem} ${classes.menuWarn}`} onClick={() => { setMenuAnchor(null); onLeaveGroup(); }}>
                <ExitToAppIcon /> {i18n.t("chatIndex.menu.leave")}
              </MenuItem>
            )}
            {(isAdmin || isOwner || !grp) && (
              <MenuItem className={`${classes.menuItem} ${classes.menuDanger}`} onClick={() => { setMenuAnchor(null); onDeleteChat(); }}>
                <DeleteOutlineIcon /> {i18n.t("chatIndex.menu.delete")}
              </MenuItem>
            )}
          </Menu>
        </div>
      </div>

      {searchOpen && (
        <div className={classes.searchBar}>
          <InputBase className={classes.searchInput} autoFocus placeholder={i18n.t("chatIndex.searchInChatPlaceholder")} value={search} onChange={(e) => setSearch(e.target.value)} startAdornment={<SearchIcon />} />
          <IconButton size="small" onClick={() => { setSearchOpen(false); setSearch(""); }} aria-label={i18n.t("aeros.chat.closeSearch")}>
            <CloseIcon style={{ fontSize: 16 }} />
          </IconButton>
        </div>
      )}

      <div ref={listRef} className={`messageList ${classes.list}`} onScroll={handleScroll}>
        {loadingMore && (
          <div className={classes.loadingMore}>
            <CircularProgress size={18} />
          </div>
        )}
        {visible.map((m, i) => {
          const prev = i > 0 ? visible[i - 1] : null;
          const me = Number(m.senderId) === Number(user.id);
          const cont = isContinuation(prev, m);
          const newDay = !prev || new Date(prev.createdAt).toDateString() !== new Date(m.createdAt).toDateString();
          const showActions = !m.isDeleted || isAdmin;
          return (
            <Fragment key={m.id}>
              {newDay && <div className={classes.divider}>{dayLabel(m.createdAt)}</div>}
              {m.isSystem ? (
                <div className={classes.system}>{m.message}</div>
              ) : (
                <div ref={(el) => (messageRefs.current[m.id] = el)} className={`${classes.row} ${me ? classes.rowMe : classes.rowOther}`} onDoubleClick={() => !m.isDeleted && setReplyingTo(m)}>
                  {cont ? (
                    <span className={classes.avatarGap} />
                  ) : (
                    <span className={classes.avatar} style={{ backgroundColor: avatarColorFor(m.senderId) }} title={m.sender?.name}>
                      {profileImageUrl(m.sender) ? <img src={profileImageUrl(m.sender)} alt="" /> : initialsOf(m.sender?.name)}
                    </span>
                  )}
                  <div className={`${classes.bubble} ${me ? classes.bubbleMe : ""} ${m.isDeleted ? classes.bubbleDeleted : ""} ${highlighted === m.id ? classes.highlight : ""}`}>
                    {showActions && !String(m.id).startsWith("temp-") && (
                      <div className={classes.toolbar}>
                        {!m.isDeleted && (
                          <>
                            <Tooltip title={i18n.t("chatMessages.reply")}><IconButton className={classes.toolBtn} onClick={() => { setReplyingTo(m); inputRef.current?.focus(); }}><ReplyIcon /></IconButton></Tooltip>
                            <Tooltip title={i18n.t("chatMessages.forward")}><IconButton className={classes.toolBtn} onClick={() => onForward(m)}><ForwardIcon /></IconButton></Tooltip>
                            <Tooltip title={i18n.t("chatMessages.react")}><IconButton className={classes.toolBtn} onClick={(e) => setReactAnchor({ el: e.currentTarget, message: m })}><InsertEmoticonIcon /></IconButton></Tooltip>
                            <Tooltip title={i18n.t("chatMessages.copy")}><IconButton className={classes.toolBtn} onClick={() => copyText(m)}><FileCopyOutlinedIcon /></IconButton></Tooltip>
                            {canEdit(m) && <Tooltip title={i18n.t("chatMessages.edit")}><IconButton className={classes.toolBtn} onClick={() => onEdit(m)}><EditIcon /></IconButton></Tooltip>}
                          </>
                        )}
                        {(me || isAdmin) && !m.isDeleted && (
                          <>
                            <span className={classes.toolSep} />
                            <Tooltip title={i18n.t("chatMessages.delete")}><IconButton className={`${classes.toolBtn} ${classes.toolDanger}`} onClick={() => onDelete(m)}><DeleteOutlineIcon /></IconButton></Tooltip>
                          </>
                        )}
                      </div>
                    )}
                    {!me && !cont && grp && !m.isDeleted && (
                      <div className={classes.sender} style={{ color: avatarColorFor(m.senderId) }}>{(m.sender?.name || "").split(" ")[0]}</div>
                    )}
                    {m.isDeleted ? (
                      <>
                        <div className={classes.deletedText}><BlockIcon /> {i18n.t("chatMessages.deleted")}</div>
                        {isAdmin && m.message && (
                          <div className={classes.deletedAdmin}>{i18n.t("chatMessages.deletedAdminShort")}: "{m.message}"</div>
                        )}
                      </>
                    ) : (
                      <>
                        {m.forwardedFrom && (
                          <div className={classes.forwarded}><ForwardIcon /> {i18n.t("chatMessages.forwardedLabel")}</div>
                        )}
                        {m.ticket && (
                          <div className={classes.ticketCard} onClick={() => m.ticket.uuid && history.push(`/tickets/${m.ticket.uuid}`)} title={i18n.t("chatMessages.openTicket")}>
                            <ConfirmationNumberOutlinedIcon />
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div className={classes.ticketTitle}>Ticket #{m.ticket.id}{m.ticket.contact?.name ? ` · ${m.ticket.contact.name}` : ""}</div>
                              <div className={classes.ticketSub}>{[m.ticket.queue?.name, m.ticket.user?.name].filter(Boolean).join(" · ") || m.ticket.status}</div>
                            </div>
                            <OpenInNewIcon />
                          </div>
                        )}
                        {m.replyTo && (
                          <div className={classes.quote} onClick={() => scrollToMessage(m.replyTo.id)} title={i18n.t("chatMessages.clickToGoToOriginal")}>
                            <div className={classes.quoteName}>{(m.replyTo.sender?.name || "").split(" ")[0] || i18n.t("chatMessages.message")}</div>
                            <div className={classes.quoteText}>{m.replyTo.message || "…"}</div>
                          </div>
                        )}
                        {renderMedia(m)}
                        {m.forwardedFrom?.mediaPath && renderMedia(m.forwardedFrom)}
                        {m.message && (
                          <div className={classes.text}>
                            <MarkdownWrapper>{m.message}</MarkdownWrapper>
                          </div>
                        )}
                        {m.reactions?.length > 0 && (
                          <div className={classes.reactions}>
                            {groupReactions(m.reactions, user.id).map((r) => (
                              <button type="button" key={r.emoji} className={`${classes.reaction} ${r.mine ? classes.reactionMine : ""}`} onClick={() => react(m, r.emoji)} title={r.names.join(", ")}>
                                {r.emoji} {r.count}
                              </button>
                            ))}
                          </div>
                        )}
                      </>
                    )}
                    <div className={`${classes.meta} ${me ? classes.metaMe : ""}`}>
                      {m.isEdited && !m.isDeleted && <i>{i18n.t("chatMessages.editedLabel")} ·</i>}
                      {hhmm(m.createdAt)}
                      {me && !m.isDeleted && <span>✓✓</span>}
                    </div>
                  </div>
                </div>
              )}
            </Fragment>
          );
        })}
        <div ref={baseRef} />
      </div>

      <div className={classes.footer}>
        {recording ? (
          <div className={classes.recRow}>
            <IconButton className={classes.recCancel} onClick={cancelAudio} disabled={sending} aria-label={i18n.t("aeros.chat.cancelRecording")}>
              <DeleteOutlineIcon />
            </IconButton>
            <span className={classes.recDot} />
            <div className={classes.recTimer}>{sending ? <CircularProgress size={16} /> : <RecordingTimer />}</div>
            <div className={classes.wave}>
              {WAVE.map((h, i) => (
                <span key={i} className={classes.waveBar} style={{ height: h }} />
              ))}
            </div>
            <IconButton className={`${classes.sendBtn} ${classes.sendOk}`} onClick={sendAudio} disabled={sending} aria-label={i18n.t("aeros.chat.sendAudio")}>
              <CheckIcon />
            </IconButton>
          </div>
        ) : medias.length > 0 ? (
          <div className={`${classes.composer} ${classes.fileCard}`}>
            <div className={classes.fileIcon}>{medias[0].type?.startsWith("image/") ? <ImageOutlinedIcon /> : <InsertDriveFileOutlinedIcon />}</div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className={classes.fileName}>{medias[0].name}{medias.length > 1 ? ` +${medias.length - 1}` : ""}</div>
              <div className={classes.fileMeta}>{formatBytes(medias[0].size)} · {i18n.t("chatMessages.readyToSend")}</div>
            </div>
            <IconButton className={classes.iconBtn} onClick={() => setMedias([])} disabled={sending} aria-label={i18n.t("aeros.chat.removeAttachment")}>
              <CloseIcon style={{ fontSize: 15 }} />
            </IconButton>
            <IconButton className={classes.sendBtn} onClick={sendMedia} disabled={sending} aria-label={i18n.t("aeros.chat.sendAttachment")}>
              {sending ? <CircularProgress size={16} style={{ color: "#07080D" }} /> : <SendIcon />}
            </IconButton>
          </div>
        ) : (
          <div className={classes.composer}>
            {replyingTo && (
              <div className={classes.replyBar}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className={classes.replyName}>{i18n.t("chatMessages.replyingTo")} {(replyingTo.sender?.name || "").split(" ")[0]}</div>
                  <div className={classes.replyText}>{replyingTo.message || replyingTo.mediaName || "…"}</div>
                </div>
                <IconButton size="small" onClick={() => setReplyingTo(null)} aria-label={i18n.t("aeros.chat.cancelReply")}>
                  <CloseIcon style={{ fontSize: 16 }} />
                </IconButton>
              </div>
            )}
            {pendingTicket && (
              <div className={classes.pendingTicket}>
                <ConfirmationNumberOutlinedIcon /> Ticket #{pendingTicket.id}{pendingTicket.contact?.name ? ` · ${pendingTicket.contact.name}` : ""}
                <IconButton size="small" style={{ marginLeft: "auto" }} onClick={() => setPendingTicket(null)} aria-label={i18n.t("aeros.chat.removeTicket")}><CloseIcon style={{ fontSize: 14 }} /></IconButton>
              </div>
            )}
            {mentionOptions.length > 0 && (
              <div className={classes.mentionPop} style={{ position: "absolute", bottom: "100%", left: 12, marginBottom: 6, zIndex: 5 }}>
                {mentionOptions.map((u) => (
                  <button type="button" key={u.userId} className={classes.mentionRow} onClick={() => { setContentMessage((t) => applyMention(t, u.user.name)); inputRef.current?.focus(); }}>
                    <span className={classes.mentionAvatar} style={{ backgroundColor: avatarColorFor(u.userId) }}>{initialsOf(u.user.name)}</span>
                    {u.user.name}
                  </button>
                ))}
              </div>
            )}
            {showEmoji && (
              <ClickAwayListener onClickAway={() => setShowEmoji(false)}>
                <div className={classes.emojiBox}>
                  <Picker perLine={16} theme="dark" showPreview={false} showSkinTones={false} onSelect={(e) => { setContentMessage((p) => p + e.native); inputRef.current?.focus(); }} />
                </div>
              </ClickAwayListener>
            )}
            <div className={classes.inputRow}>
              <IconButton className={classes.compIcon} onClick={() => setShowEmoji((v) => !v)} aria-label={i18n.t("aeros.chat.emoji")}><MoodIcon /></IconButton>
              <input type="file" id="chat-upload" multiple style={{ display: "none" }} onChange={(e) => setMedias(Array.from(e.target.files || []))} />
              <label htmlFor="chat-upload">
                <IconButton className={classes.compIcon} component="span" aria-label={i18n.t("aeros.chat.attach")}><AttachFileIcon /></IconButton>
              </label>
              <Tooltip title={i18n.t("chatMessages.linkTicket")}>
                <IconButton className={`${classes.compIcon} ${pendingTicket ? classes.compIconOn : ""}`} onClick={(e) => { setTicketAnchor(e.currentTarget); setTicketNumber(""); setTicketPreview(null); }} aria-label={i18n.t("chatMessages.linkTicket")}><ConfirmationNumberOutlinedIcon /></IconButton>
              </Tooltip>
              <InputBase
                inputRef={inputRef}
                className={classes.input}
                multiline
                rowsMax={5}
                placeholder={i18n.t(grp ? "chatMessages.placeholderGroup" : "chatMessages.placeholderDm")}
                value={contentMessage}
                onChange={(e) => { setContentMessage(e.target.value); onTypingChange(); }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && !e.shiftKey) {
                    e.preventDefault();
                    sendText(contentMessage);
                  }
                }}
                onPaste={(e) => {
                  if (e.clipboardData.files.length > 0) {
                    setMedias(Array.from(e.clipboardData.files));
                    e.preventDefault();
                  }
                }}
              />
              {contentMessage.trim() ? (
                <IconButton className={classes.sendBtn} onClick={() => sendText(contentMessage)} aria-label={i18n.t("aeros.chat.send")}><SendIcon /></IconButton>
              ) : (
                <>
                  <IconButton className={classes.compIcon} onClick={startRecording} aria-label={i18n.t("aeros.chat.record")}><MicIcon /></IconButton>
                  <IconButton className={classes.sendBtn} disabled aria-label={i18n.t("aeros.chat.send")}><SendIcon /></IconButton>
                </>
              )}
            </div>
          </div>
        )}
      </div>

      <DocumentModal open={Boolean(documentModal)} onClose={() => setDocumentModal(null)} document={documentModal} />

      <Popover open={Boolean(reactAnchor)} anchorEl={reactAnchor?.el} onClose={() => setReactAnchor(null)} anchorOrigin={{ vertical: "top", horizontal: "center" }} transformOrigin={{ vertical: "bottom", horizontal: "center" }} PaperProps={{ style: { borderRadius: 10 } }}>
        <div className={classes.reactPicker}>
          {QUICK_REACTIONS.map((e) => (
            <button type="button" key={e} onClick={() => react(reactAnchor.message, e)} aria-label={e}>{e}</button>
          ))}
        </div>
      </Popover>

      <Popover open={Boolean(ticketAnchor)} anchorEl={ticketAnchor} onClose={() => setTicketAnchor(null)} anchorOrigin={{ vertical: "top", horizontal: "left" }} transformOrigin={{ vertical: "bottom", horizontal: "left" }} PaperProps={{ className: classes.ticketPop }}>
        <div className={classes.ticketTitle}>{i18n.t("chatMessages.linkTicket")}</div>
        <InputBase className={classes.ticketInput} autoFocus type="number" placeholder={i18n.t("chatMessages.ticketNumber")} value={ticketNumber} onChange={(e) => { setTicketNumber(e.target.value); loadTicketPreview(e.target.value); }} inputProps={{ min: 1 }} />
        {ticketPreview && !ticketPreview.error && (
          <div className={classes.ticketCard} style={{ marginBottom: 0, cursor: "default" }}>
            <ConfirmationNumberOutlinedIcon />
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className={classes.ticketTitle}>Ticket #{ticketPreview.id}{ticketPreview.contact?.name ? ` · ${ticketPreview.contact.name}` : ""}</div>
              <div className={classes.ticketSub}>{[ticketPreview.queue?.name, ticketPreview.user?.name].filter(Boolean).join(" · ") || ticketPreview.status}</div>
            </div>
          </div>
        )}
        {ticketPreview?.error && <div className={classes.ticketSub}>{i18n.t("chatMessages.ticketNotFound")}</div>}
        <Button variant="contained" color="primary" size="small" style={{ borderRadius: 9, fontWeight: 700 }} disabled={!ticketPreview || ticketPreview.error} onClick={() => { setPendingTicket(ticketPreview); setTicketAnchor(null); inputRef.current?.focus(); }}>
          {i18n.t("chatMessages.attachTicket")}
        </Button>
      </Popover>
    </div>
  );
}
